import { Router } from '@angular/router';
import { environment } from '@envs/environment';

export const redirectToAccessDenied = (router: Router): void => {
  if (environment.isStandalonePortal) {
    router.navigate(['/403']);
    return;
  }
  const { localDomain } = environment;
  const ACCESSDENIED_ROUTE = '/403';
  const url = localDomain + ACCESSDENIED_ROUTE;
  window.open(url, '_self');
};
